<template #default="{ hide }">
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top shadow bg-dark">
  <div class="container">
    <a class="navbar-brand" href="#">
        <img :src="logo" alt="">
    </a>
    <button  class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div class="navbar-nav ms-auto">
        <router-link to="/" class="nav-link">Home</router-link>
        <router-link to="/about" class="nav-link">About</router-link>
        <router-link to="/project" class="nav-link">Project</router-link>
      </div>
    </div>
  </div>
</nav>
</template>
<script>
    export default {
       data () {
            return{
                logo : require('../assets/logo.png')
            }
       }
    }

</script>
<style scoped>
    .nav-link{
        color: #ffff;
        font-size: 1rem;
    } 
    .navbar-toggler{
        border: unset;
    }
    /* Large Desktop */
    @media(min-width: 1025px){
        .nav-link{
            margin-left: 30px;
        }
    }
    /* Tablet and Desktop */
    @media(max-width: 1024px){
        .nav-link{
            margin-left: 30px;
        }
    }
    /* Handphone */
    @media(max-width: 767px){
       .nav-link{
          margin-left: none;
       }
    }
</style>